import { Component, computed, input } from '@angular/core';
import { CollapsibleSpeed } from './collapsible-speed.enum';

const DURATION_CLASSES: Record<CollapsibleSpeed, string> = {
	[CollapsibleSpeed.FAST]: 'duration-200',
	[CollapsibleSpeed.SLOW]: 'duration-300',
};

const EXPANDED_CLASS = 'grid-rows-[1fr]';
const COLLAPSED_CLASS = 'grid-rows-[0fr]';
const TOUCH_EXPANDED_CLASS = '[@media(hover:none)]:grid-rows-[1fr]';

@Component({
	selector: 'ui-collapsible',
	imports: [],
	templateUrl: './collapsible.component.html',
	host: { class: 'block' },
})
export class CollapsibleComponent {
	expanded = input.required<boolean>();
	speed = input<CollapsibleSpeed>(CollapsibleSpeed.FAST);
	expandOnTouch = input<boolean>(false);

	classes = computed(() => {
		const classes = [
			DURATION_CLASSES[this.speed()],
			this.expanded() ? EXPANDED_CLASS : COLLAPSED_CLASS,
		];
		if (this.expandOnTouch()) {
			classes.push(TOUCH_EXPANDED_CLASS);
		}
		return classes.join(' ');
	});
}
